module.exports = __webpack_public_path__ + "img/spektrum.cf49e7ba.png";